/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Knp_Guide_Delete_TextInputs */

const en_knp_guide_delete_text = /** @type {(inputs: Knp_Guide_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.title}"? This will also delete all terms.`)
};

const fr_knp_guide_delete_text = /** @type {(inputs: Knp_Guide_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer « ${i?.title} » ? Cela supprimera aussi tous les termes.`)
};

const de_knp_guide_delete_text = /** @type {(inputs: Knp_Guide_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie "${i?.title}" wirklich löschen? Dadurch werden auch alle Einträge gelöscht.`)
};

const it_knp_guide_delete_text = /** @type {(inputs: Knp_Guide_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vuoi davvero eliminare "${i?.title}"? Verranno eliminati anche tutti i termini.`)
};

const ru_knp_guide_delete_text = /** @type {(inputs: Knp_Guide_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить "${i?.title}"? Это также удалит все термины.`)
};

const es_knp_guide_delete_text = /** @type {(inputs: Knp_Guide_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Seguro que desea eliminar "${i?.title}"? Esto también eliminará todos los términos.`)
};

const zh_cn2_knp_guide_delete_text = /** @type {(inputs: Knp_Guide_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要删除“${i?.title}”吗？这将同时删除所有相关术语。`)
};

const ja_knp_guide_delete_text = /** @type {(inputs: Knp_Guide_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を削除してもよろしいですか？これにより、すべての用語も削除されます。`)
};

const hi_knp_guide_delete_text = /** @type {(inputs: Knp_Guide_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई "${i?.title}" को हटाना चाहते हैं? इससे सभी शब्द भी हट जाएंगे।`)
};

const pt_pt2_knp_guide_delete_text = /** @type {(inputs: Knp_Guide_Delete_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir "${i?.title}"? Isso também excluirá todos os termos.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{title}\"? This will also delete all terms." |
*
* @param {Knp_Guide_Delete_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_delete_text = /** @type {((inputs: Knp_Guide_Delete_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Delete_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_delete_text(inputs)
	if (locale === "de") return de_knp_guide_delete_text(inputs)
	if (locale === "it") return it_knp_guide_delete_text(inputs)
	if (locale === "ru") return ru_knp_guide_delete_text(inputs)
	if (locale === "es") return es_knp_guide_delete_text(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_delete_text(inputs)
	if (locale === "ja") return ja_knp_guide_delete_text(inputs)
	if (locale === "hi") return hi_knp_guide_delete_text(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_delete_text(inputs)
	return en_knp_guide_delete_text(inputs)
});